import ImpactActor from './ImpactActor';

export default ImpactActor;
